import React from 'react';
import { Quote } from 'lucide-react';
export function SocialProof() {
  return <section className="py-24 bg-white" data-id="element-200">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-201">
        <div className="flex justify-center mb-8" data-id="element-202">
          <div className="bg-emerald-100 p-4 rounded-full" data-id="element-203">
            <Quote className="w-8 h-8 text-emerald-600" data-id="element-204" />
          </div>
        </div>

        <blockquote className="text-2xl md:text-4xl font-medium text-slate-900 leading-relaxed mb-8" data-id="element-205">
          "I'm getting more jobs with the same ad spend. The auto response
          system is booking me almost 10 new estimates per week, and almost half
          of them become clients."
        </blockquote>

        <div className="mb-4" data-id="element-206">
          <cite className="not-italic font-bold text-slate-900 text-lg" data-id="element-207">
            - Phoenix Landscaping Company Owner
          </cite>
        </div>

        <p className="text-sm text-slate-400" data-id="element-208">
          Results may vary based on market conditions and business operations
        </p>
      </div>
    </section>;
}